<svelte:head>
  <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js"></script>
</svelte:head>

<script lang="ts">
  import Mercy from './components/Mercy.svelte';
  import { onMount } from 'svelte';
  import anime from 'animejs';

  onMount(async () => {
    let timeline = anime.timeline();
    timeline.add({
      targets: '.letters path',
      strokeDashoffset: [anime.setDashoffset, 0],
      duration: 1000,
      easing: 'easeInOutSine',
      delay: anime.stagger(200),
    });
    timeline.add({
      targets: ['h2', 'h3'],
      opacity: [0, 1],
      duration: 800,
      easing: 'linear',
    }, 200);
  });

  function openCalendly() {
    Calendly.initPopupWidget({url: 'https://calendly.com/mercyt/session'});
  }

  onMount(() => {
    setTimeout(() => {
      Calendly.initBadgeWidget(
        {
          url: 'https://calendly.com/mercyt/session',
          text: 'Schedule a Massage',
          parentElement: document.getElementById('calendly-embed'),
          color: '#006bff',
          textColor: '#ffffff',
          branding: true,
        });
    }, 1000);
  });
  let vbWidth: number = 0;
  let vbHeight: number = 0;
</script>

<main bind:clientWidth="{ vbWidth }" bind:clientHeight="{ vbHeight }">
  <div id="menu">
    <ul>
      <li>
        <a href="#about">
          About
        </a>
      </li>
      <li>
        <a href="#book">
          Book
        </a>
      </li>
      <li>
        <a href="#reviews">
          Reviews
        </a>
      </li>
    </ul>
  </div>
  <div class="main-col">
    <div class="main-item letters">
      <Mercy />
    </div>
    <div class="main-item">
      <div class="blurb container" id="about">
        <p>
          Our bodies are complex creatures. They toil for us, day in and day out, they endure. They carry you through the ever-expanding, challenging landscape of this life. Allow yourself time to realign and restore with Mercy Therapeutics.
        </p>
        <img alt="Two hands reaching for each other" class="main-img" src="god_hand.jpg" />
      </div>
      <div class="blurb container">
        <img alt="Mercy in Sedona" class="main-img" src="mercy_sedona_2.jpg" />
        <p>
          Mercedes is a certified practitioner of the Ida P. Rolf method of Structural Integration. In her sessions she utilizes S.I., Connective Tissue Massage, and Nurturing Touch. Want to feel your cells elongated and stretched like taffy? Sure. Want to feel supported and held like a delicate flower and maybe even cry a little? Got you.
        </p>
      </div>
    </div>
    <div class="main-item" id="book">
      <div class="blurb">
        <p style="text-align: center">
        <span class="fuzz">Treat yo'self.</span> <a href=";" on:click|preventDefault={openCalendly}>Book now</a>
        </p>
        <p><span style="text-decoration: underline">Above the Collar</span>
        <br><br>
        This is a thorough dive on everything above the collar bone including the neck, cranium, face, trapezius, buccal area, and intraoral (inside mouth) areas. This treatment is perfect for people who suffer from TMJ, tension headaches, and general tightness of the neck or face. Loosening up the head can provide a lot of mental clarity and gives the face a more relaxed expression overall. 60 minute sessions.</p>

        <p><span style="text-decoration: underline">Nurturing Touch</span>
        <br><br>
        These sessions let your body and mind soften and relax. Light to medium pressure massage that is meant to soothe.</p>

        <p><span style="text-decoration: underline">Connective Tissue Massage</span>
        <br><br>
        This modality works on lengthening and untwisting the fascial layer. Imagine you are wearing a wet-suit that is too tight. I am going to pull and move the entire wetsuit around so you feel like you have more space in your body, to move, breathe, and exist with less tension. 60-90 minute sessions.</p>


        <p><span style="text-decoration: underline">Structural Integration &amp; &lsquo;The Ten Series&rsquo;</span>
        <br><br>
        I will assess your alignment and focus on reorganizing your body from various positions on the table. This work is often done in a series of 10 sessions, called The Ten Series. Each session has a unique goal and is focused on taking twist and deorganization out, thoroughly going over each section of your body.<br><br>
        This treatment is very good for people with chronic pain or posture issues, as well as people who want to increase movement and function with their daily motions. This modality lets the client take an active role in their improvement and gives you more awareness of what is happening inside of yourself. 90 minute sessions.</p>
        <p>
          Hot towel service is included with every massage.
        </p>
        <div class="price-container">
          <span style="grid-column: 1/-1; padding-bottom: 0.5em; font-weight: 700;">Offerings</span>
          <span>Above the Collar</span><span>&vert;</span><span>$90</span><span>&vert;</span><span>60 min</span>
          <span>Nurturing Touch</span><span>&vert;</span><span>$100</span><span>&vert;</span><span>60 min</span>
          <span>Connective Tissue <span class="optional-text">Massage</span></span><span>&vert;</span><span>$100</span><span>&vert;</span><span>60 min</span>
          <span>&nbsp;</span><span>&vert;</span><span>$130</span><span>&vert;</span><span>90 min</span>
          <span>S.I. Session</span><span>&vert;</span><span>$130</span><span>&vert;</span><span>90 min</span>
          <span>In-Home Offerings</span><span>&vert;</span><span>$170</span><span>&vert;</span><span>90 min</span>
        </div>
      </div>
    </div>
    <div class="main-item">
      <div class="blurb">
        <p style="text-align: center" class="fuzz">
          My Path
        </p>
        <p>
        I began my career at a young age as an in-home massage caregiver to a sick relative. Raised as a nurturer, it made Massage Therapy a natural career for me to enter in 2019. My initial certification in massage therapy was earned at Saint Paul College, where I specialized in deep tissue, Swedish, and trigger point therapy. From there I went on to hone my skills at the Institute of Structural Integration in Minneapolis. This modality is where my true passion in body work lies. My own healing and mobility journey helps shape my practice as well. As a dancer and musician, I seamlessly weave elements of rhythm and movement into my practice. My background in dance also enhances my ability to address the needs of my clients by deepening my understanding of the human body.
        </p>
        <p style="text-align: center">
          Contact
        </p>
        <a href="mailto:mercytherapeutics@gmail.com">mercytherapeutics@gmail.com</a>
        &vert;
        612-524-8470
      </div>
    </div>
    <div class="main-item" id="reviews">
      <div class="blurb">
        <p style="text-align: center" class="fuzz">
          Reviews
        </p>
        <p style="font-weight: 300;font-size: 15pt;">
        &ldquo;Mercedes is one of my favorite people to get bodywork from. I always feel so taken care of and I can relax so deeply knowing I’m in such good hands. She has strong intuitive skills and sometimes blends in her energy work which makes it for an extra magical experience. She has supported me healing through some tough days post auto-accident, and I’m incredibly grateful for her work. Thank you Mercedes, I can’t wait to get back on your table - your sessions are the best!&rdquo;<br />&ndash;Z
        </p>
      </div>
    </div>
  </div>
  <div id="calendly-embed"></div>
</main>

<style>
  main {
    margin: 0 auto;
    background-color: #cce6c8;
  }
  #menu {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #cce6c8;
    border-radius: 10px;
  }
  #menu ul {
    display: flex;
    flex-direction: row;
    padding: 0 20px;
    gap: 5px;
  }
  a {
    color: cornflowerblue;
  }
  li {
    list-style-type: none;
  }
  li a {
    color: OrangeRed;
  }
  .main-col {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 50px 0;
  }
  .main-item {
    margin: 30px 20%;
  }
  .main-img {
    max-height: 250px;
    border-radius: 10px;
  }
  .letters {
    margin: 10px 10%;
  }
  .blurb {
    margin: 20px 0;
    padding: 10px 20px;
    font-size: 18pt;
    /*background-color: #a8d9ec;*/
    background-color: LightCyan;
    /*color: #fe973b;*/
    color: OrangeRed;
    font-family: 'Comfortaa';
    font-weight: bold;
    border-radius: 10px;
  }
  .fuzz {
    text-shadow: 4px 4px 2px LightGrey;
  }
  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
  .price-container {
    display: grid;
    font-weight: 400;
    grid-template-columns: max-content 40px max-content 40px max-content;
    justify-items: center;
    justify-content: center;
  }
  @media (max-width: 900px) {
    .main-col {
      padding: 50px 0;
    }
    .main-item {
      margin: 30px 0;
    }
    .main-img {
      max-height: initial;
      max-width: 100%;
    }
    .letters {
      margin: 10px 5%;
    }
    .blurb {
      margin: 5px 5%;
      font-size: 14pt;
    }
    .container {
      flex-direction: column;
    }
    .price-container {
      grid-template-columns: max-content 20px max-content 20px max-content;
    }
    .optional-text {
      display: none;
    }
  }
</style>
